module.exports = __webpack_public_path__ + "media/images/kirby_eat-087cdaafb6206e65dba849555c745c07.gif";